module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-146.aae5932.woff2";